import * as React from 'react';

import {
  IControlError,
  IControlSchema,
  IControlSchemaBase,
} from '../../../core/Controls';
import { IDispatcher } from '../../helpers/Dispatcher';

import RangeCalendar, { IRangeCalendarSchema } from './RangeCalendar';
import Calendar, { ICalendarSchema } from './Calendar';

export function createCalendar(
  schema: IControlSchema,
  api: any,

  dispatcher: IDispatcher = null,
  error: IControlError | undefined,
  visited: boolean,
): React.ReactElement<any> {
  const sh = schema as ICalendarSchema;
  return sh.finishDate !== null ? (
    <RangeCalendar
      schema={schema as IRangeCalendarSchema}
      api={api}
      error={error}
      visited={visited}
      dispatcher={dispatcher}
    />
  ) : (
    <Calendar
      schema={schema as ICalendarSchema}
      api={api}
      error={error}
      visited={visited}
      dispatcher={dispatcher}
    />
  );
}
